import { render, staticRenderFns } from "./LastRejectionMessage.vue?vue&type=template&id=4834edaa&scoped=true&"
import script from "./LastRejectionMessage.vue?vue&type=script&lang=ts&"
export * from "./LastRejectionMessage.vue?vue&type=script&lang=ts&"
import style0 from "./LastRejectionMessage.vue?vue&type=style&index=0&id=4834edaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4834edaa",
  null
  
)

export default component.exports